import { Link } from 'react-router-dom';
import { learnerships } from '../../data/mockData';
import { ButtonLink } from '../ui/Button';
import SectionHeading from '../ui/SectionHeading';
import learnershipsImage from '../../assets/learnerships-image.jpg';

export default function Learnerships() {
  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={learnershipsImage}
          alt="Learnerships background"
          className="h-full w-full object-cover"
          loading="lazy"
        />
        {/* Overlay for content contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/40 to-white/20" />
      </div>

      <div className="section-shell relative z-10">
        <SectionHeading
          align="left"
          eyebrow="Accredited qualifications"
          title="Our MICT SETA learnerships"
          description="Twelve-month programmes leading to a SAQA-registered national certificate. Theory, practical work, and workplace experience in one structured year."
          action={
            <ButtonLink to="/apply" variant="secondary" size="md">
              How to apply
            </ButtonLink>
          }
        />

        <div className="mt-12 grid gap-6 sm:grid-cols-2 xl:grid-cols-4">
          {learnerships.map((course) => (
            <Link
              key={course.id}
              to={`/learnerships/${course.saqaId}`}
              className="card-surface card-surface-hover group flex flex-col overflow-hidden"
            >
              <div
                className={`relative aspect-[16/10] bg-gradient-to-br ${course.gradient}`}
              >
                {course.badge && (
                  <span className="absolute left-4 top-4 rounded-full bg-white/95 px-3 py-1 text-xs font-bold text-brand-800">
                    {course.badge}
                  </span>
                )}
                <span className="absolute bottom-4 left-4 rounded-full bg-brand-950/40 px-3 py-1 text-xs font-semibold text-white backdrop-blur">
                  SAQA {course.saqaId}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="text-base font-bold leading-snug text-brand-950 group-hover:text-brand-700">
                  {course.title}
                </h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-brand-900/60">
                  {course.summary}
                </p>

                <dl className="mt-5 grid grid-cols-3 gap-2 border-t border-canvas-200 pt-4">
                  <div>
                    <dt className="text-xs text-brand-900/45">NQF</dt>
                    <dd className="text-sm font-bold text-brand-950">
                      {course.nqfLevel ?? '—'}
                    </dd>
                  </div>
                  <div>
                    <dt className="text-xs text-brand-900/45">Credits</dt>
                    <dd className="text-sm font-bold text-brand-950">
                      {course.credits ?? '—'}
                    </dd>
                  </div>
                  <div>
                    <dt className="text-xs text-brand-900/45">Duration</dt>
                    <dd className="text-sm font-bold text-brand-950">
                      {course.durationMonths} mo
                    </dd>
                  </div>
                </dl>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
